import { Course } from "@models/ISchema";
import { AdaptedCourse } from "../models";

export const courseAdapter = (course: Course): AdaptedCourse => {
  const courseTags = course?.tags ? JSON.parse(course?.tags) : {};
  return { ...course, tags: courseTags } as AdaptedCourse;
};
